
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1595299959859",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2081",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "500",
    "height": "500"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M286.72 290.133c17.067 0 30.72-13.653 30.72-34.133 0-105.813 95.573-170.667 191.147-170.667 92.16 0 194.56 71.68 194.56 170.667 0 20.48 13.653 34.133 30.72 34.133s30.72-13.653 30.72-34.133c0-139.947-136.534-238.933-256-238.933-122.88 0-256 88.746-256 238.933 3.413 17.067 17.066 34.133 34.133 34.133z m648.533 102.4c-17.066-20.48-44.373-34.133-71.68-34.133H160.427c-27.307 0-54.614 10.24-71.68 34.133-17.067 20.48-23.894 47.787-20.48 75.094L143.36 911.36c10.24 54.613 61.44 98.987 116.053 98.987h505.174c54.613 0 105.813-40.96 116.053-98.987l75.093-443.733c3.414-27.307-3.413-54.614-20.48-75.094z m-645.12 204.8c-27.306 0-51.2-23.893-51.2-51.2s23.894-51.2 51.2-51.2 51.2 23.894 51.2 51.2-23.893 51.2-51.2 51.2z m443.734 0c-27.307 0-51.2-23.893-51.2-51.2s23.893-51.2 51.2-51.2 51.2 23.894 51.2 51.2-23.894 51.2-51.2 51.2z",
        "p-id": "2082"
      }
    }
  ]
})
    }
  